import React from "react";
import Issues from "./Issues";

function App() {
  return (
    <>
      <Issues />
    </>
  );
}

export default App;
